import { StavPripomienkyEnum } from 'pripomienky-web-ts-axios';
import MultiChoiceItem from '../../types/MultiChoiceItem';

enum StavPripomienky {
  AKCEPTOVANA = 'Akceptovaná',
  CIASTOCNE_AKCEPTOVANA = 'Čiastočne akceptovaná',
  NEAKCEPTOVANA = 'Neakceptovaná',
  NEPRIHLIADA_SA = 'Neprihliada sa',
  NESPRACOVANA = 'Nespracovaná',
  STORNOVANA = 'Stornovaná',
  ZRUSENA = 'Zrušená'
}

export default StavPripomienky;

export const stavPripomienkyValues = [StavPripomienky.AKCEPTOVANA, StavPripomienky.CIASTOCNE_AKCEPTOVANA,
  StavPripomienky.NEAKCEPTOVANA, StavPripomienky.NESPRACOVANA, StavPripomienky.NEPRIHLIADA_SA];

export const generatedToStavPripomienkyMap = new Map([
  [StavPripomienkyEnum.Akceptovana, StavPripomienky.AKCEPTOVANA],
  [StavPripomienkyEnum.CiastocneAkceptovana, StavPripomienky.CIASTOCNE_AKCEPTOVANA],
  [StavPripomienkyEnum.Neakceptovana, StavPripomienky.NEAKCEPTOVANA],
  [StavPripomienkyEnum.NeprihliadaSa, StavPripomienky.NEPRIHLIADA_SA],
  [StavPripomienkyEnum.Nespracovana, StavPripomienky.NESPRACOVANA],
  [StavPripomienkyEnum.Stornovana, StavPripomienky.STORNOVANA],
  [StavPripomienkyEnum.Zrusena, StavPripomienky.ZRUSENA],
]);

export const stavPripomienkyToGeneratedMap = new Map([
  [StavPripomienky.AKCEPTOVANA, StavPripomienkyEnum.Akceptovana],
  [StavPripomienky.CIASTOCNE_AKCEPTOVANA, StavPripomienkyEnum.CiastocneAkceptovana],
  [StavPripomienky.NEAKCEPTOVANA, StavPripomienkyEnum.Neakceptovana],
  [StavPripomienky.NEPRIHLIADA_SA, StavPripomienkyEnum.NeprihliadaSa],
  [StavPripomienky.NESPRACOVANA, StavPripomienkyEnum.Nespracovana],
  [StavPripomienky.STORNOVANA, StavPripomienkyEnum.Stornovana],
  [StavPripomienky.ZRUSENA, StavPripomienkyEnum.Zrusena],
]);

export const stringToGeneratedMap = new Map([
  ['akceptovana', StavPripomienkyEnum.Akceptovana],
  ['ciastocne_akc', StavPripomienkyEnum.CiastocneAkceptovana],
  ['neakceptovana', StavPripomienkyEnum.Neakceptovana],
  ['neprihliada_sa', StavPripomienkyEnum.NeprihliadaSa],
  ['nespracovana', StavPripomienkyEnum.Nespracovana],
  ['stornovana', StavPripomienkyEnum.Stornovana],
  ['zrusena', StavPripomienkyEnum.Zrusena],
]);

const stavPripomienkyToTagClassMap = new Map<StavPripomienky, 'success'
  | 'danger' | 'warning' | 'notice' | 'info' | 'primary'>([
    [StavPripomienky.AKCEPTOVANA, 'success'],
    [StavPripomienky.CIASTOCNE_AKCEPTOVANA, 'success'],
    [StavPripomienky.NEAKCEPTOVANA, 'danger'],
    [StavPripomienky.NEPRIHLIADA_SA, 'warning'],
    [StavPripomienky.NESPRACOVANA, 'notice'],
    [StavPripomienky.STORNOVANA, 'info'],
    [StavPripomienky.ZRUSENA, 'info'],
  ]);

export const stavPripomienkyMultichoice: MultiChoiceItem[] = [
  { id: 'akceptovana', label: StavPripomienky.AKCEPTOVANA, checked: true },
  { id: 'ciastocne_akc', label: StavPripomienky.CIASTOCNE_AKCEPTOVANA, checked: true },
  { id: 'neakceptovana', label: StavPripomienky.NEAKCEPTOVANA, checked: true },
  { id: 'neprihliada_sa', label: StavPripomienky.NEPRIHLIADA_SA, checked: true },
  { id: 'nespracovana', label: StavPripomienky.NESPRACOVANA, checked: true },
  { id: 'stornovana', label: StavPripomienky.STORNOVANA, checked: true },
  { id: 'zrusena', label: StavPripomienky.ZRUSENA, checked: true },
];
export function generatedToStavPripomienky(generated: StavPripomienkyEnum): StavPripomienky {
  return generatedToStavPripomienkyMap.get(generated);
}

export function stringToGeneratedStav(stavPripomienky: string): StavPripomienkyEnum {
  return stringToGeneratedMap.get(stavPripomienky);
}

export function stavPripomienkyToGenerated(stavPripomienky: StavPripomienky): StavPripomienkyEnum {
  return stavPripomienkyToGeneratedMap.get(stavPripomienky);
}

export function stavPripomienkyToTagClass(stavPripomienky: StavPripomienky): 'success'
  | 'danger' | 'warning' | 'notice' | 'info' | 'primary' {
  return stavPripomienkyToTagClassMap.get(stavPripomienky);
}
